import { render, staticRenderFns } from "./language.view.vue?vue&type=template&id=277a11e7"
import script from "./language.view.vue?vue&type=script&lang=js"
export * from "./language.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports